import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const ReservationsSecondaryViewStore = GenericFieldFactory("RESERVATIONS_SECONDARY_VIEW", null);